import React, { useEffect } from 'react';
import { useOrganization } from '../../contexts/organizationContext';
import { useTranslation } from 'react-i18next';
import Icon from '../icon/Icon';

/**
 * Organization Display Component
 *
 * Displays the currently selected organization name in the header.
 * Single-organization mode: no dropdown, just displays the name.
 */
const OrganizationDropdown = () => {
	const { t } = useTranslation(['organization', 'common']);
	const { selectedOrganization, isLoading, fetchOrganizations } = useOrganization();

	useEffect(() => {
		// Fetch organizations on mount to ensure we have the selected one
		fetchOrganizations().catch((error) => {
			console.error('Error fetching organizations:', error);
		});
	}, [fetchOrganizations]);

	if (isLoading) {
		return (
			<div className='d-flex align-items-center'>
				<Icon icon='Business' className='me-2' size='lg' color='primary' />
				<span className='fw-bold text-muted'>{t('Loading')}...</span>
			</div>
		);
	}

	if (!selectedOrganization) {
		return (
			<div className='d-flex align-items-center'>
				<Icon icon='Business' className='me-2' size='lg' color='warning' />
				<span className='fw-bold text-warning'>{t('No Organization Selected')}</span>
			</div>
		);
	}

	return (
		<div className='d-flex align-items-center'>
			<Icon icon='Business' className='me-2' size='lg' color='primary' />
			<span className='fw-bold text-primary'>{selectedOrganization.name}</span>
		</div>
	);
};

export default OrganizationDropdown;
